/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type {
  Cuid,
  ListPublicVideosParams,
  PublicVideoWithSurvey,
  ScenarioVideoWithUrl,
  SurveyResponseResponse,
  VideoSurveyImpressionInput,
  VideoSurveyResponseInput,
  VideoSurveySubmissionInput,
} from '.././model'

import {
  default as getPublicVideoMutator,
  default as listPublicVideosMutator,
  default as recordVideoSurveyImpressionMutator,
  default as submitVideoSurveyFormMutator,
  default as submitVideoSurveyResponseMutator,
} from '../../../customFetch'

/**
 * 公開動画一覧を取得
指定されたテナントの公開動画一覧を取得します。
isPublished=trueの動画のみを返却し、displayOrder昇順でソートします。
tagIdを指定した場合、そのタグが付与された動画のみを返却します。
 */
export const listPublicVideos = (params: ListPublicVideosParams) => {
  return listPublicVideosMutator<ScenarioVideoWithUrl[]>({ url: `/public/videos`, method: 'GET', params })
}
/**
 * 公開動画詳細を取得
公開されている動画の詳細を取得します。
非公開の動画にアクセスすると404エラーを返します。
動画URLは署名付きURL（24時間有効）です。
 */
export const getPublicVideo = (videoId: Cuid) => {
  return getPublicVideoMutator<PublicVideoWithSurvey>({ url: `/public/videos/${videoId}`, method: 'GET' })
}
/**
 * 動画紐づきアンケートの回答を保存（動画詳細ページ）

アンケートの持ち主は動画なので（ADR-0015）、シナリオ文脈が無くても回答を受けられる。
関連動画付きページ（`?from=`）では流入元プレイリストも記録するが、発生元は
動画詳細ページとして区別される。非公開動画・アンケート未設定は存在秘匿のため
success:true の no-op になる。
 */
export const submitVideoSurveyResponse = (videoId: Cuid, videoSurveyResponseInput: VideoSurveyResponseInput) => {
  return submitVideoSurveyResponseMutator<SurveyResponseResponse>({
    url: `/public/videos/${videoId}/survey-responses`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: videoSurveyResponseInput,
  })
}
/**
 * 動画紐づきアンケートのフォームを一括送信（PII 混在・動画詳細ページ）

非PII設問（回答表）とリード項目（PII・リード表）が混在するフォーム全体を単一
トランザクションで atomic に振り分け保存する（部分保存なし）。必須設問が1つでも
未回答ならフォーム全体を 400 で拒否する。
 */
export const submitVideoSurveyForm = (videoId: Cuid, videoSurveySubmissionInput: VideoSurveySubmissionInput) => {
  return submitVideoSurveyFormMutator<SurveyResponseResponse>({
    url: `/public/videos/${videoId}/survey-submissions`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: videoSurveySubmissionInput,
  })
}
/**
 * アンケートの提示到達を記録（到達→完了ファネル用・ADR-0015）

視聴セッション × テンプレ × 動画で重複排除するので、同じ視聴で何度提示されても1件。
 */
export const recordVideoSurveyImpression = (videoId: Cuid, videoSurveyImpressionInput: VideoSurveyImpressionInput) => {
  return recordVideoSurveyImpressionMutator<SurveyResponseResponse>({
    url: `/public/videos/${videoId}/survey-impressions`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: videoSurveyImpressionInput,
  })
}
export type ListPublicVideosResult = NonNullable<Awaited<ReturnType<typeof listPublicVideos>>>
export type GetPublicVideoResult = NonNullable<Awaited<ReturnType<typeof getPublicVideo>>>
export type SubmitVideoSurveyResponseResult = NonNullable<Awaited<ReturnType<typeof submitVideoSurveyResponse>>>
export type SubmitVideoSurveyFormResult = NonNullable<Awaited<ReturnType<typeof submitVideoSurveyForm>>>
export type RecordVideoSurveyImpressionResult = NonNullable<Awaited<ReturnType<typeof recordVideoSurveyImpression>>>
